import React from 'react';
import { Menu, Image, Icon} from 'semantic-ui-react'
import { Link } from 'react-router-dom';


const Header = (props) => {

  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backgroundColor: 'white'
    }}>

    <div className="ui top attached menu borderless large fitted" style={{ backgroundColor: "#008000",
          marginBottom: '-2px'}}>
            {/* <Container textAlign='left'> */}
            <Menu.Item header style={{color:'white', marginLeft: '130px'}}>

               <Link style={{color:'white', fontWeight: 1}} to="/">
               <Icon name='home' size='small' />Home               </Link>
               {/* <StyledSpan> */}
                  <Link style={{color:'white',marginLeft: '15px', fontWeight: 1}} to ="/events/results">Results</Link>
               {/* </StyledSpan> */}
               <Link style={{color:'white',marginLeft: '15px', fontWeight: 1}} to="/events">
                   Games
               </Link>
               {/* <StyledSpan> */}
                  <Link style={{color:'white',marginLeft: '15px', fontWeight: 1}} to ="/news">News</Link>
               {/* </StyledSpan> */}

              {props.isAuthenticated
                ? <React.Fragment><Link style={{color:'white',marginLeft: '15px', fontWeight: 1}} to="/events/list"> Manage-Games </Link>
               <Link style={{color:'white', marginLeft: '15px', fontWeight: 1}} to="/logout">Logout</Link></React.Fragment>
              : <Link style={{color:'white', marginLeft: '15px', fontWeight: 1}} to="/login">Login</Link>}

           </Menu.Item>
           <Menu.Item  position='right'>
           </Menu.Item>
            {/* </Container> */}
           </div>

            <div className="ui middle attached borderless menu" style={{ backgroundColor: "white",  borderTopStyle: 'solid', marginBottom: '-6px', marginTop: '-6px'}}>
              {/* <Container textAlign='left'> */}
                <Menu.Item>
                <Link to ="/" style={{color:'black', marginLeft: '110px'}} ><Image size='medium' src='/images/wireframe/black-logo.png' /></Link>
                </Menu.Item>
                <Menu.Item position='right'>
                  <Icon name='mail' size='large'/><a style={{ color: "black", padding: '8px'}} href={`mailto:donalireland@gmail.com`}>donalireland@gmail.com</a>

                </Menu.Item>
              {/* </Container> */}
            </div>
            
            {/* <div className="ui bottom attached inverted borderless fitted menu" style={{backgroundColor: "white", 
               maxHeight:'200px' }}> */}
              {/* borderColor: 'black', borderTopStyle: 'solid', */}
              {/* <Container>
                       
              </Container> 
            </div> */}

            
    </div>
  )
};

export default Header;
